import { render, staticRenderFns } from "./utwl-student-select.vue?vue&type=template&id=38f81aa0"
import script from "./utwl-student-select.vue?vue&type=script&lang=js"
export * from "./utwl-student-select.vue?vue&type=script&lang=js"
import style0 from "./utwl-student-select.vue?vue&type=style&index=0&id=38f81aa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports